import { useModal } from "@/Contexts";
import ModalContainer from "@/components/modalContainer";
import { useTrans } from "@/translations";

export const DeleteEventModal: React.FC<{
  eventId: string;
  deleteEvent: ({ id }: { id: string }) => Promise<void>;
}> = ({ eventId, deleteEvent }) => {
  const { t } = useTrans();
  const { hideModal } = useModal();

  const onConfirm = () => {
    hideModal();
    deleteEvent({ id: eventId });
  };

  return (
    <ModalContainer
      title={"actions:deleteRow"}
      onConfirmText={"actions:confirm"}
      onConfirm={onConfirm}
      onCancel={hideModal}
    >
      <div className="pt-3">
        <p>{t("hints:areYouSureDeleteEvent")}</p>
      </div>
    </ModalContainer>
  );
};
